/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Avatar, Typography } from '@mui/material';
import moment from 'moment';
import FlagTwoToneIcon from '@mui/icons-material/FlagTwoTone';
import StatusColumn from '../../../record-viewer/status-column';

type TaskStatus = 'Open' | 'In Progress' | 'Complete';
type IssueStatus = 'Needs resolution' | 'Resolved';
type StatusEnum = TaskStatus | IssueStatus;

export interface MapCardIssueObject {
  key: string;
  title: string;
  reportedBy: string;
  createdById: string;
  status: StatusEnum;
  priority: string;
  created_at: string;
}

export interface RecordMapCard {
  cardData: Record<string, any>;
  rowNodes: MapCardRowItem[];
}

export interface MapCardRowItem {
  text: string;
  children: React.ReactNode[];
}

const priorityColor = {
  None: '#26C04D',
  Low: '#3D4043',
  Medium: '#FF9500',
  High: '#FF3B30',
  Critical: '#AF52DE',
};

export const buildRecordTitlesFieldKeys = (
  titlesArray: string[],
  columsForm: Record<string, any>[],
): Record<string, any> => {
  const availableKeys = columsForm.reduce((accumulator, current) => (
    { ...accumulator, [current.name]: current.field }
  ), {});
  return titlesArray.reduce((acc, curr) => ({ ...acc, [curr]: availableKeys[curr] }), {});
};

export const getRecordMapCardElements = (
  record: Record<string, any>,
  queryColumnsForm: Record<string, any>[],
  systemType: string,
): RecordMapCard => {
  if (systemType === 'basic_issue') {
    const issuesTitleKeys = buildRecordTitlesFieldKeys(['title', 'priority'], queryColumnsForm);

    const issueObject: MapCardIssueObject = {
      key: record.record_key,
      title: record.form_values[issuesTitleKeys.title],
      reportedBy: record?.created_by,
      createdById: record?.created_by_id,
      status: record.status,
      priority: (record.form_values[issuesTitleKeys.priority] && record.form_values[issuesTitleKeys.priority].choice_values[0] !== '')
        ? record.form_values[issuesTitleKeys.priority].choice_values[0]
        : 'None',
      created_at: record.created_at,
    };

    const rowNodes = [
      {
        text: 'Reported by',
        children: [
          <Avatar sx={{ width: 24, height: 24, marginRight: 1 }} alt={record?.created_by} src={`/users/${issueObject.createdById}/avatar`} />,
          <Typography variant="body2">{issueObject.reportedBy}</Typography>,
        ],
      },
      {
        text: 'Date reported',
        children: [
          <Typography variant="body2">{moment(issueObject.created_at).format('MMM DD, YYYY')}</Typography>,
        ],
      },
      {
        text: 'Status',
        children: [
          <StatusColumn size={10} height={20} capitalized value={issueObject.status} />,
        ],
      },
      {
        text: 'Priority',
        children: [
          <FlagTwoToneIcon sx={{ marginRight: '7px', color: priorityColor[issueObject.priority], fontSize: 18 }} />,
          <Typography variant="body2">{issueObject.priority}</Typography>,
        ],
      },
    ];
    return {
      cardData: issueObject,
      rowNodes,
    };
  }
  return {
    cardData: {},
    rowNodes: [],
  };
};
